import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { constant } from "../app.constants";
const reqOptns = {
    headers: new HttpHeaders().set("isLoadNotReq", "true")
}
@Injectable()
export class PrimeEscService {

    constructor(private _http: HttpClient) { }

    getSignHistoryByPatientId(patientId: any): Observable<any> {
        return this._http.get<any>(
            constant.GET_Signatures_ByPatient.replace("{patientId}", "" + patientId), reqOptns
        );
    }

    getPatAckSign(transId: any, sigtype: any, loaderNtReq?: boolean): Observable<any> {
        let options = loaderNtReq 
            ? { headers: new HttpHeaders().set("isLoadNotReq", "true") } 
            : {};
        return this._http.get<any>(
            constant.GET_Signature_ACKSign
                .replace("{transId}", "" + transId)
                .replace("{sigtype}", "" + sigtype)
        ,options);
    }

    getSignTransHist(filterData: any): Observable<any> {
        return this._http.post<any>(
            constant.POST_Signature_TransHist, filterData, reqOptns
        );
    }

    getPatientSignPrint(transId: any, sigtype: any, refillId: any): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set("Accept", "application/pdf");
        return this._http.get(
            constant.GET_Signature_Print
                .replace("{transId}", "" + transId)
                .replace("{sigtype}", "" + sigtype)
                .replace("{refillId}", "" + refillId)
            ,
            { headers: headers, responseType: "blob" }
        );
    }

    getSignatureReport(dataToPost: any): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set("Accept", "application/pdf").set("isLoadNotReq", "true");
        return this._http.post(
            constant.POST_Signature_GenerateReport, dataToPost, { headers: headers, responseType: "blob" }
        );
    }

    getSignByPatient(dataToPost: any): Observable<any> {
        return this._http.post<any>(
            constant.POST_Signature_ByDate, dataToPost, reqOptns
        );
    }

    getSignByRx(rxnum: any): Observable<any> {
        return this._http.get<any>(
            constant.GET_PrimeEsc_SearchByRx
                .replace("{rxnum}", "" + rxnum)
        , reqOptns);
    }

    getPOSreceipt(pickUpRxId: any): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set("Accept", "application/pdf");
        return this._http.get(
            constant.GET_POSReceipt_Print
                .replace("{pickUpRxId}", "" + pickUpRxId)
            ,
            { headers: headers, responseType: "blob" }
        );
    }

    getPOSReceiptInfo(payLoad: any): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set("Accept", "application/pdf");
        return this._http.post(
            constant.POST_Print_POSReceipt
            , payLoad, { headers: headers, responseType: "blob" }
        );
    }

    printPOSPickUpDetails(payload:any): Observable<any> {
        return this._http.post(constant.POST_Print_PickupDetails, payload);
    }

}
